import { Button, Spin } from 'antd';
import { antIcon } from 'components/pages/Login';
import React, { useEffect, useRef } from 'react';
import { restrictedCharsForInput } from 'utils/helperMethods';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { colorConstants } from 'config/colorConstants';

interface ITextboxProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    onApplyChange: () => void;
    maxLength: number;
    errorText?: string;
    textBoxValidation?: boolean;
    alreadyExist?: boolean;
    disableBlur?: boolean;
    showLoader?: boolean;
    onCancel?: () => void;
}

const Textbox = (props: ITextboxProps) => {
    const {
        onChange,
        value,
        onApplyChange,
        errorText = '',
        textBoxValidation = false,
        maxLength,
        alreadyExist = false,
        disableBlur,
        showLoader,
        onCancel,
    } = props;

    const isWrongInput = (inputText: string) =>
        textBoxValidation || alreadyExist || restrictedCharsForInput.some((char: string) => !!inputText.includes(char));

    const inputRef = useRef<any>(null);

    useEffect(() => {
        inputRef?.current?.focus();
    }, []);

    return (
        <div className="flex flex-col">
            <div className="flex">
                <input
                    ref={inputRef}
                    type="text"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event)}
                    onBlur={() => !disableBlur && onApplyChange()}
                    value={value}
                    maxLength={maxLength}
                    className="border-b-2 border-purpleFont mr-4 outline-none text-fontGray font-lg"
                />
                <div className="flex justify-center items-center gap-2">
                    <Button
                        type="text"
                        icon={
                            showLoader ? (
                                <Spin indicator={antIcon} style={{ color: colorConstants.violet }} />
                            ) : (
                                <CheckOutlined />
                            )
                        }
                        onClick={onApplyChange}
                    />
                    <Button type="text" icon={<CloseOutlined />} onClick={onCancel} disabled={showLoader} />
                </div>
            </div>
            {isWrongInput(value) && <span className={'text-redTriangle text-xs'}>{errorText}</span>}
        </div>
    );
};

export default Textbox;
